import { render, staticRenderFns } from "./SidemenuItemsPartner.vue?vue&type=template&id=256237a3"
import script from "./SidemenuItemsPartner.vue?vue&type=script&lang=js"
export * from "./SidemenuItemsPartner.vue?vue&type=script&lang=js"
import style0 from "./SidemenuItemsPartner.vue?vue&type=style&index=0&id=256237a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports